<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(slide, index) in slides">
                <img class="slide-image" v-bind:src="slide"/>
                <p>Slide: {{ index + 1 }}</p>
            </div>
        </div>

        <div class="swiper-pagination"></div>

        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div>
</template>

<script>
    import * as Swiper from 'swiper';
    import * as contentful from 'contentful';
    export default {
        data() {
            return {
                slides: [],
				content_client: null
            }
        },
        mounted() {
            const swiper = new Swiper ('.swiper-container', {
                pagination: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                paginationClickable: true,
                observer: true
            });

            this.content_client = contentful.createClient({
                space: process.env.SPACE_ID,
                accessToken: process.env.CMS_TOKEN
            });

            this.content_client.getEntries({
                content_type: 'module_slider',
                'fields.module_number': this.$route.params.module_number
            }).then((response) => {
                this.slides = response.items[0].fields.slide_images.map((item) => {
                    return item.fields.file.url;
                });
            }).catch(console.error);
        },
		watch: {
			$route() {
				this.content_client.getEntries({
	                content_type: 'slider',
	                'fields.module_number': 'Module ' + this.$route.params.module_number
	            }).then((response) => {
	                this.slides = response.items[0].fields.slide_images.map((item) => {
	                    return item.fields.file.url;
	                });
	            }).catch(console.error);
			}
		}
    }
</script>

<style lang="scss">
    @import '~swiper/dist/css/swiper.min.css';

    .swiper-container {
        max-width: 1400px;
    }

    .slide-image {
        display: block;
        width: calc(100% - 100px);
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// slider.vue?3c2b48ee